import { UserName } from "./userName";
import { Settings } from "./settings";
import { Logout } from "./logout";

export function SideMenu() {
  return (
    <>
      <div className={"p-8 flex flex-col items-end flex-1"}>
        <label htmlFor={"main-drawer"} className={"self-start"}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6"
          >
            <path
              fillRule="evenodd"
              d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
              clipRule="evenodd"
            />
          </svg>
        </label>
        <UserName />
        <div className={"flex-1"}></div>
        <Settings />
        <div className={"flex-1"}></div>
        <Logout />
      </div>
    </>
  );
}
